export const SpecialtyCodes = [
  'cardiology',
  'general_medicine',
  'pediatrics',
  'gynecology',
  'serum_therapy'
] as const;

export type SpecialtyCode = typeof SpecialtyCodes[number];

export class Specialty {
  id: string;
  code: SpecialtyCode;
  name: string;
  color: string;

  constructor({
    id,
    code,
    name,
    color
  }: {
    id: string;
    code: SpecialtyCode;
    name: string;
    color: string;
  }) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.color = color;
  }
}
